import { MenuItem, Select, type SelectChangeEvent } from "@mychili/ui-web";
import { useTranslation } from "react-i18next";

// @todo refactor with clarity-ui
export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange = (e: SelectChangeEvent<unknown>) => {
    if (typeof e.target.value === "string") {
      i18n.changeLanguage(e.target.value);
    }
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      sx={{
        width: "88px",
        height: "44px",
        borderRadius: "8px",
        backgroundColor: "#F5F5F5",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5rem",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
      }}
    >
      <MenuItem key="en" value="en">
        Eng
      </MenuItem>
      <MenuItem key="ms" value="ms">
        My
      </MenuItem>
    </Select>
  );
};
